import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import validator from 'validator';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { InfinitySpin } from 'react-loader-spinner';
import Sidebar from '../components/Sidebar';
import { withAuth } from '../hoc/withAuth';
import { changePassword } from '../redux/slices/auth';
import {
  exchangeRate,
  updateExchangeRate,
  generateReport,
} from '../redux/slices/forecast';

const Setting = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isChangePasswordLoading = useSelector(
    (state) => state.auth.isChangePasswordLoading
  );
  const isUpdateExchangeRateLoading = useSelector(
    (state) => state.forecast.isUpdateExchangeRateLoading
  );
  const { forecastNumber, forecastPeriod } = useSelector(
    (state) => state.forecast.forecastInfo
  );
  const { latest, id } = useSelector((state) => state.forecast.rate);
  const { selectedPeriod } = useSelector(
    (state) => state.forecast.forecastDropdown
  );
  let isGeneratingReport = useSelector(
    (state) => state.forecast.isGeneratingReport
  );

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [latestRate, setLatestRate] = useState(latest);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');

  const changeCurrentPasswordHandler = (e) =>
    setCurrentPassword(e.target.value);

  const changeNewPasswordHandler = (e) => setNewPassword(e.target.value);

  const exchangeRateHandler = (e) => setLatestRate(e.target.value);

  const updateExchangeRateHandler = async (e) => {
    e.preventDefault();
    dispatch(
      updateExchangeRate({ id, latestRate, forecastNumber, forecastPeriod })
    );
  };

  const changePasswordHandler = async (e) => {
    e.preventDefault();

    if (
      !validator.isStrongPassword(newPassword, {
        minLength: 6,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      toast.error(
        'Password must be more than 5 characters including number, symbol, upper and lowercase',
        { autoClose: 5000 }
      );
      return;
    }

    dispatch(changePassword({ currentPassword, newPassword })).then((res) => {
      if (!res.payload) return;

      setCurrentPassword('');
      setNewPassword('');
      navigate('/setting');
    });
  };

  const toggleCurrentPasswordVisibility = (e) => {
    e.preventDefault();
    setShowCurrentPassword(!showCurrentPassword);
  };

  const toggleNewPasswordVisibility = (e) => {
    e.preventDefault();
    setShowNewPassword(!showNewPassword);
  };

  useEffect(() => {
    // Get exchange rate from backend
    dispatch(exchangeRate({ forecastNumber, forecastPeriod }));
    if (latestRate != latest) {
      dispatch(
        generateReport({ id: selectedPeriod, forecastNumber, forecastPeriod })
      );
    }
    setLatestRate(latest);
  }, [latest]);

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        {/* Navbar */}
        <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
          <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
            {/* Brand */}
            <a
              className=" text-xl  hidden lg:inline-block font-semibold"
              href="#pablo"
              style={{color:'#671c2d'}}
              onClick={(e) => e.preventDefault()}
            >
              Settings
            </a>
          </div>
        </nav>
        {/* End Navbar */}
        {/* Header */}
        <div className="hidden sm:block" aria-hidden="true">
              <div className="py-14">
                <div className="border-t border-gray-200"></div>
              </div>
            </div>

        {isGeneratingReport && (
          <>
            <div className="grid h-screen place-items-center">
              <div>
                <h1>Please wait while we generate your report</h1>
                <div className="text-center text-md font-bold text-red">
                  Do not leave this page
                </div>
                <div className="flex items-center justify-center">
                  <InfinitySpin width="200" color="red" />
                </div>
              </div>
            </div>
          </>
        )}

        {!isGeneratingReport && (
          <div className=' grid grid-cols-2 w-full relative left-14'>
          <div className=''>
          <div className="">
                        <h1 className="text-black font-bold text-lg mb-1">
                         Update Exchange rate
                        </h1>
                        <h1 className="text-md font-normal text-gray-600 mb-7">
                          Exchange rate
                        </h1>
                      </div>
          </div>
            <div className="">
              <form
                className=""
                onSubmit={updateExchangeRateHandler}
              >
                <div className="">
                  <div className="">
                    <div className="">
                  
                      <div className="relative w-9/12">
                        <input
                          type="text"
                          className="w-full px-4 py-3 rounded-lg bg-white mt-2 border focus:border-grey-200
                                            focus:bg-white focus:outline-none"
                          placeholder="Update exchange rate"
                          style={{ transition: 'all .15s ease' }}
                          value={latestRate || ''}
                          onChange={exchangeRateHandler}
                        />
                      </div>
                      <div className="pt-6">
                        <button
                          type="submit"
                          style={{backgroundColor:'#df3c62'}}
                          disabled={isUpdateExchangeRateLoading}
                          className="inline-flex justify-center py-3 px-16 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-300"
                        >
                          {isUpdateExchangeRateLoading || isGeneratingReport
                            ? 'loading...'
                            : 'Update'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

        {!isGeneratingReport && (
          <>
            <div className=' grid grid-cols-2 gap-28  m-14'>
            <div className=''>
             
             <h1 className="text-black font-bold text-lg mb-3">
               Physical Metrics and Activity
             </h1>
             <h1 className="text-md font-normal text-gray-600 mb-7">
               To change your passwod, please type in the current
               password and your new password.
             </h1>
           </div>
           <form className="" onSubmit={changePasswordHandler}>
                <div className="">
                  <div className="relative w-9/12">
                    <div className="text-gray-600 flex items-center pr-5 pb-4 h-full cursor-pointer">
                    </div>
                    <input
                      type={showCurrentPassword && 'text'}
                      id="currentPassword"
                      placeholder="Enter current password"
                      style={{ transition: 'all .15s ease' }}
                      value={currentPassword}
                      onChange={changeCurrentPasswordHandler}
                      required
                      className="w-full px-4 py-3 rounded-lg bg-white mt-2 border focus:border-grey-200
                    focus:bg-white focus:outline-none"
                    />
                  </div>

                  <div className="relative w-9/12 mb-5 mt-2">
                    <div className="absolute right-0 text-gray-600 flex items-center pr-5 pb-4 py-6 px-5  cursor-pointer">
                    </div>
                    <input
                      type={showNewPassword && 'text'}
                      className="w-full px-4 py-3 rounded-lg bg-white mt-2 border focus:border-grey-200
                                    focus:bg-white focus:outline-none"
                      placeholder="Enter new password"
                      style={{ transition: 'all .15s ease' }}
                      value={newPassword}
                      onChange={changeNewPasswordHandler}
                      required
                    />
                    <div className=" py-6  ">
                      <button
                        type="submit"
                        disabled={isChangePasswordLoading}
                        style={{backgroundColor:'#df3c62'}}
                        className="inline-flex  py-3 px-16 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                      >
                        {isChangePasswordLoading ? 'loading...' : 'Submit'}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
         
       </div>
     
          </>
        )}
      </div>
    </>
  );
};

export default withAuth(true)(Setting);
